"use strict";

exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 原有高阶组件功能废弃 在微信android版中组件嵌套过多导致pushState在back的时候回刷新页面
 * 新版本中只对组件封装context,propTypes,defaultProps
 * 这个不算BUG的问题用了三天时间才发现 我都日了微信了
 * @param obj
 * @param options
 * @returns {*}
 */
function _default(obj, options, displayName) {
  if (options === void 0) {
    options = {};
  }

  if (displayName === void 0) {
    displayName = '';
  }

  //let childContextTypes = obj.childContextTypes || {}
  //obj.childContextTypes = {
  //    ...childContextTypes,
  //    events: Props.object,
  //}
  ////
  //let contextTypes = contextTypes || {};
  //obj.contextTypes = {
  //    ...contextTypes,
  //    events: Props.object,
  //};
  //
  var propTypes = obj.propTypes || {};
  obj.propTypes = _objectSpread(_objectSpread({}, propTypes), options.propTypes || {}); //

  var defaultProps = obj.defaultProps || {};
  obj.defaultProps = _objectSpread(_objectSpread({}, defaultProps), options.defaultProps || {}); //

  obj.displayName = displayName;
  return obj;
}

;
module.exports = exports.default;